<template>
  <div>
    <div v-if="isEditable" class="questionLine">
      <div></div>
    </div>
    <div class="question-item" :class="[!isEditable ? 'mt-4' : 'mt-0', { 'mb-0': isLast }]">
      <div class="w-100">
        <validation-observer v-slot="{ validate }" class="item">
          <validate-form class="question-title-textarea" :id="`questionTitle${indexAt}`" v-model="question.title"
            which-component="b-form-textarea" rows="1" max-rows="1" ref="croppieRef" :disabled="!isEditable"
            rules="required|min:10" @keypress="maxLengthCheck($event, 750, 'title')"
            @keyup="maxLengthCheck($event, 750, 'title')" @input="handleInput($event, validate, indexAt)"
            :name='resource["question"]' :placeholder="resource['hrvenue.interviewQuestionPlaceholder']" no-resize>
            <div slot="customLabel">
              <b-row class="mb-3">
                <b-col class="d-flex align-items-center">
                  <span v-if="isEditable" class="handle dragIcon"
                    :class="{ 'disabled': totalQuestionCount === 1 }">
                    <i class="icon-order" />
                  </span>

                  <h4 class="d-inline question-title">
                    {{ `${order + 1}. ` + resource["question"] }}
                  </h4>
                </b-col>
                <b-col v-if="showDeleteButton">
                  <span @click="clickDelete"
                    class="cursor-pointer float-right d-flex align-items-center delete-icon-content" :title="getTitle"
                  >
                    <i :class="['icon-delete-two', 'delete-icon']" />
                  </span>
                </b-col>
              </b-row>
            </div>
          </validate-form>
        </validation-observer>
      </div>

      <div class="time-selection" v-if="pageType !== 'question' && questionType === 1">
        <div>
          <p class="sm fw-500 mb-2">{{ resource["hrvenue.InterviewEdit.ThinkTime"] }}</p>
          <div class="user-filter">
            <multiselect id="thinkTime" v-model="thinkTimeModel" :disabled="!isEditable" v-bind="optionsThinkTime"
              :show-no-results="false" @input="changeFilters('thinkTime')"
              :style="mutableIsThinkTimeEmpty && 'border: 1px solid red;'">
              <template slot="singleLabel" slot-scope="props">
                <span class="option__desc">
                  <span class="option__title">
                    {{ props.option.displayName }}
                  </span>
                </span>
                <svg class="time-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M11.6682 1.25H8.33488C7.87655 1.25 7.50155 1.625 7.50155 2.08333C7.50155 2.54167 7.87655 2.91667 8.33488 2.91667H11.6682C12.1265 2.91667 12.5015 2.54167 12.5015 2.08333C12.5015 1.625 12.1265 1.25 11.6682 1.25ZM10.0015 12.0833C10.4599 12.0833 10.8349 11.7083 10.8349 11.25V7.91667C10.8349 7.45833 10.4599 7.08333 10.0015 7.08333C9.54321 7.08333 9.16821 7.45833 9.16821 7.91667V11.25C9.16821 11.7083 9.54321 12.0833 10.0015 12.0833ZM15.8599 6.575L16.4849 5.95C16.8015 5.63333 16.8099 5.10833 16.4849 4.78333L16.4765 4.775C16.1515 4.45 15.6349 4.45833 15.3099 4.775L14.6849 5.4C13.3932 4.36667 11.7682 3.75 10.0015 3.75C6.00155 3.75 2.60155 7.05 2.50155 11.05C2.39322 15.2833 5.78488 18.75 10.0015 18.75C14.1515 18.75 17.5015 15.3917 17.5015 11.25C17.5015 9.48333 16.8849 7.85833 15.8599 6.575ZM10.0015 17.0833C6.77655 17.0833 4.16821 14.475 4.16821 11.25C4.16821 8.025 6.77655 5.41667 10.0015 5.41667C13.2265 5.41667 15.8349 8.025 15.8349 11.25C15.8349 14.475 13.2265 17.0833 10.0015 17.0833Z" fill="#333333"/>
                </svg>
              </template>
              <span slot="noResult">{{ resource['label.NoResult'] }}</span>
            </multiselect>
          </div>
        </div>

        <div>
          <p class="sm fw-500 mb-2">{{ resource["hrvenue.InterviewEdit.AnswerTime"] }}</p>
          <div class="user-filter">
            <multiselect id="timeLimit" v-model="timeLimitModel" :disabled="!isEditable" v-bind="optionsTimeLimit"
              :show-no-results="false" @input="changeFilters('timeLimit')"
              :style="mutableIsTimeLimitEmpty && 'border: 1px solid red;'">
              <template slot="singleLabel" slot-scope="props">
                <span class="option__desc">
                  <span class="option__title">
                    {{ props.option.displayName }}
                  </span>
                </span>
                <svg class="time-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M11.6682 1.25H8.33488C7.87655 1.25 7.50155 1.625 7.50155 2.08333C7.50155 2.54167 7.87655 2.91667 8.33488 2.91667H11.6682C12.1265 2.91667 12.5015 2.54167 12.5015 2.08333C12.5015 1.625 12.1265 1.25 11.6682 1.25ZM10.0015 12.0833C10.4599 12.0833 10.8349 11.7083 10.8349 11.25V7.91667C10.8349 7.45833 10.4599 7.08333 10.0015 7.08333C9.54321 7.08333 9.16821 7.45833 9.16821 7.91667V11.25C9.16821 11.7083 9.54321 12.0833 10.0015 12.0833ZM15.8599 6.575L16.4849 5.95C16.8015 5.63333 16.8099 5.10833 16.4849 4.78333L16.4765 4.775C16.1515 4.45 15.6349 4.45833 15.3099 4.775L14.6849 5.4C13.3932 4.36667 11.7682 3.75 10.0015 3.75C6.00155 3.75 2.60155 7.05 2.50155 11.05C2.39322 15.2833 5.78488 18.75 10.0015 18.75C14.1515 18.75 17.5015 15.3917 17.5015 11.25C17.5015 9.48333 16.8849 7.85833 15.8599 6.575ZM10.0015 17.0833C6.77655 17.0833 4.16821 14.475 4.16821 11.25C4.16821 8.025 6.77655 5.41667 10.0015 5.41667C13.2265 5.41667 15.8349 8.025 15.8349 11.25C15.8349 14.475 13.2265 17.0833 10.0015 17.0833Z" fill="#333333"/>
                </svg>
              </template>
              <span slot="noResult">{{ resource['label.NoResult'] }}</span>
            </multiselect>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isEditable" class="questionLine">
      <div class="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InterviewQuestions',

  props: {
    question: { type: Object, required: true },
    indexAt: { type: Number, required: true },
    isEditable: { type: Boolean, default: true },
    isDelete: { type: Boolean, default: true },
    order: {
      type: Number,
      required: true,
    },
    totalQuestionCount: {
      type: Number,
      required: true,
    },
    isTimeLimitEmpty: {
      type: Boolean,
      default: false,
    },
    isThinkTimeEmpty: {
      type: Boolean,
      default: false,
    },
    questionType: {
      type: Number,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },

  components: {},

  data() {
    return {
      optionsThinkTime: {},
      optionsTimeLimit: {},
      thinkTimeModel: {},
      timeLimitModel: {},
      mutableIsTimeLimitEmpty: this.isTimeLimitEmpty,
      mutableIsThinkTimeEmpty: this.isThinkTimeEmpty,
      pageType: '',
      deleteIconClass: 'icon-delete-two',
      titleLength: 0,
      firstValue: '',
    };
  },

  computed: {
    showDeleteButton() {
      //* Eger ilk soru degilse silmeyi goster
      if (this.isDelete) {
        return this.totalQuestionCount > 1;
      }
      return false;
    },

    getTitle() {
      if (!this.isDelete) {
        return this.resource['hrvenue.InterviewEdit.SendedInterviewNotEditMessage'];
      }
      return '';
    },

    setQuestionType() {
      if (this.questionType && this.questionType === 1) {
        return 1;
      }
      return 2;
    },
  },

  mounted() {
    if (this.question.thinkTime) {
      this.thinkTimeModel = this.optionsThinkTime.options?.find(
        (item) => item.id === this.question.thinkTime,
      );

      this.timeLimitModel = this.optionsTimeLimit.options?.find(
        (item) => item.id === this.question.timeLimit,
      );
    }
  },

  created() {
    this.pageType = this.$route.path.includes('/question-generator') ? 'question' : 'interview';
    this.optionsThinkTime = this.generateConfig('think');
    this.optionsTimeLimit = this.generateConfig('time');

    const second = this.resource.second;
    this.optionsThinkTime.options = [
      { displayName: `5 ${second}`, id: 5 },
      { displayName: `15 ${second}`, id: 15 },
      { displayName: `30 ${second}`, id: 30 },
      { displayName: `45 ${second}`, id: 45 },
      { displayName: `60 ${second}`, id: 60 },
      { displayName: `90 ${second}`, id: 90 },
      { displayName: `120 ${second}`, id: 120 },
    ];

    this.optionsTimeLimit.options = [
      { displayName: `15 ${second}`, id: 15 },
      { displayName: `30 ${second}`, id: 30 },
      { displayName: `45 ${second}`, id: 45 },
      { displayName: `60 ${second}`, id: 60 },
      { displayName: `90 ${second}`, id: 90 },
      { displayName: `120 ${second}`, id: 120 },
      { displayName: `150 ${second}`, id: 150 },
    ];

    this.question.type = this.setQuestionType;
    this.question.description = '';
    this.question.order = this.order + 1;
    this.question.retake = 1;
  },

  methods: {
    isValidSelection() {
      return this.thinkTimeModel !== '';
    },
    generateConfig(type) {
      const second = this.resource.second;
      return {
        name: type === 'think' ? 'thinkTime' : 'timeLimit',
        label: 'displayName',
        trackBy: 'id',
        placeholder:
          type === 'think' ? `Maksimum 120 ${second}` : `Maksimum 150 ${second}`,
        options: [],
        searchable: true,
        allowEmpty: false,
      };
    },
    clickDelete() {
      if (this.isDelete) {
        this.$emit('onDeleteQuestion', this.order, this.question);
      }
    },

    changeFilters(type) {
      if (type === 'thinkTime') {
        this.question.thinkTime = this.thinkTimeModel.id;
        this.mutableIsThinkTimeEmpty = false;
      } else {
        this.question.timeLimit = this.timeLimitModel.id;
        this.mutableIsTimeLimitEmpty = false;
      }
    },
    setWhichInput(InpEl, value) {
      if (InpEl === 'title') {
        this.question.title = value;
      }
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;
      if (String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },

    handleInput(e, validate) {
      const inputName = `questionTitle${this.indexAt}FormInput`;
      if (this.$refs.croppieRef.$refs[inputName]) {
        this.$refs.croppieRef.$refs[inputName].$el.style.height = 'auto';
        this.$refs.croppieRef.$refs[inputName].$el.style.height = `${this.$refs.croppieRef.$refs[inputName].$el.scrollHeight + 2}px`;
      }
      this.checkValidate(validate);
    },
    checkValidate(validate) {
      if (this.question?.title !== this.firstValue && this.question?.title?.length >= 5) {
        validate();
        this.titleLength = this.question?.title.length;
      }
      if (this.question?.title.length < this.titleLength) {
        validate();
      }
    },
  },
  watch: {
    question: {
      handler(newVal) {
        if (this.question.thinkTime) {
          this.thinkTimeModel = this.optionsThinkTime.options?.find((item) => item.id === this.question.thinkTime);
          this.timeLimitModel = this.optionsTimeLimit.options?.find((item) => item.id === this.question.timeLimit);
        }
        this.firstValue = newVal.title;
        this.titleLength = newVal?.title?.length;
      },
      deep: true,
      immediate: true,
    },
    isTimeLimitEmpty: {
      handler() {
        this.mutableIsTimeLimitEmpty = this.isTimeLimitEmpty;
      },
    },
    isThinkTimeEmpty: {
      handler() {
        this.mutableIsThinkTimeEmpty = this.isThinkTimeEmpty;
      },
    },
  },
};
</script>

<style lang="scss">
@import '~@/style/starter.scss';

.job-list {
  min-height: 300px;
}

.fw-500 {
  font-weight: 500 !important;
}

.time-icon {
  position: absolute;
  z-index: 2;
  left: -22px;
  top: -1px;
}

.multiselect__tags {
  padding: 10px 40px 0 28px !important;
  display: flex;
  align-items: center;
}

.user-filter {
  display: flex;
  align-items: center;
  position: relative;

  & .multiselect {
    font-size: 13px;

    & .multiselect__select:before {
      top: 60%;
    }

    & .multiselect__input,
    .multiselect__single {
      vertical-align: unset !important;
    }

    & .multiselect__input {
      width: 0px !important;
      position: absolute !important;
      padding: 0px !important;
    }

    & .multiselect__option {
      display: flex;

      & span {
        width: 180px;
        text-overflow: ellipsis;
        overflow: hidden;

        @include media-breakpoint-down(sm) {
          width: 120px;
        }

        @include media-breakpoint-down(lg) {
          width: 140px;
        }

        @include media-breakpoint-down(xl) {
          width: 180px;
        }
      }
    }
  }

  & i {
    font-size: 16px;
    margin-left: 8px;
    position: absolute;
    right: 24px;
    z-index: 1;
  }
}

.pb-50vh {
  padding-bottom: 50vh;
}

.fs-14 {
  // position: absolute;
  // right: 16px;
  font-size: 14px !important;
  margin-left: 8px;
}

.secret-job {
  background: rgba(0, 0, 0, 0.12);
  padding: 0 4px;
  border-radius: 3px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.38);
  margin-left: 8px;
  font-weight: bold;
}

.dragIcon {
  cursor: move;
  color: #353535;
  padding-bottom: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.questionLine {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: -webkit-center;
  zoom: 1;
  display: none;

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  & div {
    width: 496px;
    height: 1px;

    @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
      width: 100%;
    }
  }
}

.question-item {
  display: flex;
  padding: var(--Padding-Large, 16px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Padding-Large, 16px);
  align-self: stretch;
  border-radius: var(--Radius-Small, 4px);
  background: var(--Background-Colors-Bright-Gray, #FAFAFA);
  margin-bottom: 12px;

  .item {
    width: 100%;
  }
}

.time-selection {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;

  div {
    flex: 1;
  }
}

.sortable-chosen {
  .question-item {
    border: 1px solid #FF8D06 !important;
  }

  .questionLine {
    display: block;
    & div {
      border: 1px solid #FF8D06;
      background-color: #FF8D06;
    }
  }
}

@media (min-width: 1200px) and (-webkit-min-device-pixel-ratio: 1.5) and (-webkit-max-device-pixel-ratio: 1.99) {
  .questionLine {
    zoom: 1.2;
  }
}

@media (min-width: 1200px) and (-webkit-min-device-pixel-ratio: 2) and (-webkit-max-device-pixel-ratio: 2.5) {
  .questionLine {
    zoom: .96;
  }
}

.question-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
}

.delete-icon-content {
  display: flex;
  width: 30px;
  height: 30px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--Radius-Round, 512px);
  border: 1px solid var(--Stroke-Colors-Secondary-Gray-Stroke, #D4D4D4);
  background: var(--Background-Colors-White, #FFF);
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: #E4E4E4;
  }
}

.delete-icon {
  font-size: 16px;
  color: #333;
}

.question-title-textarea {
  textarea {
    padding: 8px !important;
    resize: none !important;
    outline: none !important;
  }
}

.b-form-radio {
  display: flex;
  align-items: center;
}

.b-form-radio-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.time-selection {
  @media only screen and (max-width: map-get($grid-breakpoints, 'md')) {
    gap: 16px
  }
}
</style>
